import { endpoints, host } from '@config/endpoints';
import request from './request';

export const resetPasswordRequest = async (
    password: string,
    comfirmPassword: string,
    token: string,
    email: string,
) => {
    const { path, method } = endpoints.users.resetPassword;

    let err = null;
    let res: any = null;

    try {
        ({ data: res } = await request(
            `${host}${path}`,
            method,
            {
                password,
                comfirmPassword,
                token,
                email
            },
            {},
        ));
    } catch (error) {
        // @ts-ignore
        err = error.message;
    }

    return [err, res];
};
